import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import SiteManagement from '../../components/admin/SiteManagement';

const SiteManagementPage = () => {
  const { user, hasRole } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // Check if user has access to this page
  useEffect(() => {
    const checkAccess = () => {
      setLoading(true);
      
      // If not logged in, redirect to home
      if (!user) {
        navigate('/');
        return;
      }
      
      // Check if user has any staff role
      const isStaff = hasRole('ADMIN') || hasRole('MANAGEMENT');
      
      // If user doesn't have any staff role, redirect them to the regular dashboard
      if (!isStaff) {
        navigate('/dashboard');
        return;
      }
      
      setLoading(false);
    };

    checkAccess();
  }, [user, hasRole, navigate]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold mb-2">Site Management</h1>
        <div className="flex items-center">
          <span className="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            {user?.roles.join(', ')}
          </span>
          <p className="text-gray-600">
            Welcome back, {user?.firstName} {user?.lastName}
          </p>
        </div>
      </div>
      
      {/* Site Management content */}
      <div className="bg-white rounded-lg p-6 shadow">
        <SiteManagement />
      </div>
    </div>
  );
};

export default SiteManagementPage; 